import { transparentize, opacify } from 'polished';

export const setAlpha = (color: string, alpha: number): string =>
  opacify(alpha, transparentize(1, color));
